import React from "react";
import SousTitreText from "../ui/typographic/sousTitreText";
import Image from "../ui/Image";

const IconTextGrid = ({
    index,
    reference,
    isVisible,
    color,
    img,
    bckgdImg,
    titre,
    description,
    url,
    pics
}) => {
    return (
        <div className={`md:flex md:gap-4`}>
          {
            img ?
            <div className={`flex flex-none items-start justify-start mb-2 md:m-0 ${reference ? 'appear-fromright' : ''}`}>
                <Image key={index} alt={`icône ${titre}`} pics={pics} picture={img} imgClass='icon' extraClass={` w-10 rounded-lg ${bckgdImg}`} />
            </div>
            : ''
            }
            <div className="flex flex-1">
                <div>
                      <SousTitreText 
                      index={index}
                      url={url}
                      Titre={titre}
                      Text={description}
                      Color={color}
                      Reference={reference}
                      inView={isVisible}
                      />
                </div>
            </div>
        </div>
    )
}

export default IconTextGrid

